/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSetupParameterTemplateListValuesEntry } from '../../models/create-setup-parameter-template-list-values-entry';

export interface CreateSetupParameterTemplateListValues$Params {
      body: Array<CreateSetupParameterTemplateListValuesEntry>
}

export function createSetupParameterTemplateListValues(http: HttpClient, rootUrl: string, params: CreateSetupParameterTemplateListValues$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createSetupParameterTemplateListValues.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createSetupParameterTemplateListValues.PATH = '/api/v1/SetupParameter/CreateSetupParameterTemplateListValuesList';
